import stickybits from "stickybits";
import gsap from "gsap";
import { is_mobile } from "./utils";
import ScrollMagic from "scrollmagic";
import { trimEnd } from "lodash";
import imagesLoaded from "imagesloaded";
require("intersection-observer");

function app_text_scroll(controller, scrollingScenes) {
  // let stickyWrapper = $(".phone__sticky_wrapper");
  // let displayScreens = $(".app_screen");
  // let text = document.querySelector(".main-application__features ul");
  // let display = document.querySelector(".main-application__phone");
  // gsap.set(displayScreens, {
  //     opacity: 0
  // })
  // gsap.set(displayScreens[0], {
  //     opacity: 1
  // })
  // let changeImage = gsap.timeline();
  // displayScreens.each(function (i, elem) {
  //     changeImage.to(elem, {
  //         opacity: 1
  //     });
  //     changeImage.to({}, {
  //         duration: 0.3
  //     });
  // });
  // let tween = gsap.timeline()
  // tween.add(changeImage);
  // let scene = new ScrollMagic.Scene({
  //     triggerElement: stickyWrapper[0],
  // })
  //     .setTween(tween)
  //     .addTo(controller)
  // gsap.set('.phone__sticky_wrapper', {
  //     height: '100%'
  // })
  // let scrollingScene = {
  //     scene: scene,
  //     update: function () {
  //         let textBox = text.getBoundingClientRect();
  //         let displayBox = display.getBoundingClientRect();
  //         let triggerHook;
  //         let push = Math.max(0, textBox.height - displayBox.height);
  //         triggerHook = is_mobile ? 0.5 : (($(".header").height() + $(".main__navbox").height() + 10) / window.innerHeight);
  //         gsap.set(stickyWrapper, {
  //             height: displayBox.height + push
  //         })
  //         // gsap.set(display, {
  //         //     top: triggerHook * wh
  //         // })
  //         scene.triggerHook(triggerHook);
  //         scene.duration(push);
  //     }
  // }
  // scrollingScenes.push(scrollingScene);
  // scrollingScene.update();
  // document.querySelector(".main-application__in .app_screen").addEventListener("load", function () {
  //     scrollingScene.update();
  // });
}

// Original device size 320x666
const header = document.querySelector(".header");
const headerHeight = header ? header.offsetHeight : 80;

function vh(percent) {
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return (percent * h) / 100;
}

function mainApplication() {
  let el = document.querySelector(".main-application__features");

  if (!el) {
    return;
  }

  let top = document.querySelector(".phone__sticky_wrapper .image-container").offsetHeight / 2;

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".main-application__features",
        start: !is_mobile
          ? "top 50%-=" + parseInt(top - headerHeight / 2) + "px"
          : "top 50%-=" + parseInt(headerHeight / 2) + "px",
        end: !is_mobile
          ? "bottom 50%+=" + parseInt(top + headerHeight / 2) + "px"
          : "bottom 50%+=" + parseInt(top + headerHeight / 2) + "px",
        markers: new URLSearchParams(window.location.search).has("main-application-debug"),
        scrub: 0.33,
      },
    })
    .to(".main-application__phone .app_screen:nth-child(4)", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".main-application__phone .app_screen:nth-child(3)", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".main-application__phone .app_screen:nth-child(2)", {
      autoAlpha: 0,
      ease: "steps(1)",
    });

    window.dispatchEvent(new Event('resize'));
}

function displayFeatures() {
  let el = document.querySelector(".main-display__features");

  if (!el) {
    return;
  }

  let top = document.querySelector(".main-display__display").offsetHeight / 2;

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".main-display__features",
        start: !is_mobile
          ? "top 50%-=" + parseInt(top - headerHeight / 2) + "px"
          : "top 50%-=" + parseInt(headerHeight / 2) + "px",
        end: !is_mobile
          ? "bottom 50%+=" + parseInt(top + headerHeight / 2) + "px"
          : "bottom 50%+=" + parseInt(top + headerHeight / 2) + "px",
        markers: new URLSearchParams(window.location.search).has("main-display-debug"),
        scrub: 0.33,
      },
    })
    .to(".display_screen__8", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".display_screen__7", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".display_screen__6", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".display_screen__5", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".display_screen__4", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".display_screen__3", {
      autoAlpha: 0,
      ease: "steps(1)",
    })
    .to(".display_screen__2", {
      autoAlpha: 0,
      ease: "steps(1)",
    });

    window.dispatchEvent(new Event('resize'));
}

function sticky_displays(controller, scrollingScenes) {
  app_text_scroll(controller, scrollingScenes);

  let observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let elem = entry.target;

        if (!elem.dataset.scrollTriggerReady) {
          elem.dataset.scrollTriggerReady = true;

          if (elem.classList.contains("main-application__in")) {
            // imagesLoaded(".main-application__phone .image-container", mainApplication);
            mainApplication();
          } else if (elem.classList.contains("main-display__in")) {
            // imagesLoaded(".display_screen", displayFeatures);
            displayFeatures();
          }
        }
      }
    });
  });

  // $(window).on("load", function () {
  observer.observe(document.querySelector(".main-application__in"));
  observer.observe(document.querySelector(".main-display__in"));
  // });
}

export { sticky_displays };
